import React from 'react'
import moment from 'moment'
import './index.css'

import {
    H5,
    Table,
    FormikInput,
    Divider,
    Col,
    Row,
    FormikTextArea,
    Button,
    FormikSimpleSelect,
    FormikCheckbox,
    FormikCheckboxArray,
    FormikSuggestWithCreate,
    MobileListCard,
    AddCard,
    Card,
    FormikSelect,
    FormikCustomDateTimePicker,
    FormikDate
} from '../../../Elements'

import { FieldArray } from 'formik'
import { Icon } from '@blueprintjs/core'
import { useMediaQuery } from 'react-responsive'
import { GeneralComments } from './JobDetailForm'

const dividerStyle = {
    marginBottom: '20px'
}
const halfWidthStyle = {
    maxWidth: '40%',
    display: 'inline-block',
    marginRight: '10%'
}
const marginStyle = {
    marginRight: '10%'
}
const rightAlignTextStyle = {
    textAlign: 'right'
}

const AWAITING_BUILDER_STATUS = 19
const COLOR_OUT_OF_STOCK_STATUS = 20

export const WarrantyJobDetailsForm = ({ valuePrefix, jobPriorities, jobDescriptions }) => {
    return (
        <>
            <Row>
                <Col lg={6}>
                    <FormikSimpleSelect
                        name={`${valuePrefix}.warranty_details.priority`}
                        label='Job Priority'
                        items={jobPriorities}
                        nullable
                    />
                    <FormikTextArea
                        label='Special Instructions'
                        name={`${valuePrefix}.warranty_details.special_instructions`}
                    />
                </Col>
                <Col lg={6}>
                    <FormikSimpleSelect
                        name={`${valuePrefix}.warranty_details.description`}
                        label='Job Description'
                        items={jobDescriptions}
                        nullable
                    />
                    <FormikTextArea
                        label='Description Notes'
                        name={`${valuePrefix}.warranty_details.description_notes`}
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <FormikTextArea
                        label='Contact Notes'
                        name={`${valuePrefix}.warranty_details.contact_notes`}
                    />
                </Col>
            </Row>
        </>
    )
}

export const WarrantyJobForm = ({ values, valuePrefix, repairSupervisors, warrantyCategories }) => {
    return (
        <Row>
            <Col lg={6}>
                <H5>Departments</H5>
                <FormikCheckbox
                    label='Gunite'
                    name={`${valuePrefix}.warranty_details.is_gunite_division`}
                    checked={values.warranty_details.is_gunite_division}
                />
                <FormikCheckbox
                    label='Pebble'
                    name={`${valuePrefix}.warranty_details.is_pebble_division`}
                    checked={values.warranty_details.is_pebble_division}
                />
                <FormikCheckbox
                    label='Boulder Creations'
                    name={`${valuePrefix}.warranty_details.is_boulder_creations_division`}
                    checked={values.warranty_details.is_boulder_creations_division}
                />
                <H5 style={{ marginTop: '5%' }}>Chemicals</H5>
                <FormikInput
                    label='Alkalinity'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.alkalinity`}
                />
                <FormikInput
                    label='Calcium'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.calcium`}
                />
                <FormikInput
                    label='Chlorine'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.chlorine`}
                />
                <FormikInput
                    label='Cyanuric Acid'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.cyanuric_acid`}
                />
                <FormikInput
                    label='pH'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.ph`}
                />
                <FormikInput
                    label='Phosphates'
                    groupStyles={halfWidthStyle}
                    name={`${valuePrefix}.warranty_details.phosphates`}
                />
                <FormikInput
                    label='Sequestering Agent'
                    groupStyles={marginStyle}
                    name={`${valuePrefix}.warranty_details.sequestering_agent`}
                />
            </Col>
            <Col lg={6}>
                <FormikSimpleSelect
                    name={`${valuePrefix}.warranty_details.category`}
                    label='Category'
                    items={warrantyCategories}
                    nullable
                />
                <FormikSimpleSelect
                    name={`${valuePrefix}.warranty_details.repair_supervisor`}
                    label='Repair Supervisor'
                    items={repairSupervisors}
                    dependentName={`${valuePrefix}.warranty_details.other_repair_supervisor`}
                    nullable
                    withOther
                />
                {values.warranty_details.repair_supervisor && values.warranty_details.repair_supervisor.id === 99999 &&
                    <FormikInput
                        label='Repair Supervisor (Other)'
                        name={`${valuePrefix}.warranty_details.other_repair_supervisor`}
                    />
                }
                <FormikTextArea
                    label='Other Info'
                    name={`${valuePrefix}.warranty_details.other_info`}
                />
                <FormikTextArea
                    label='Report Notes'
                    name={`${valuePrefix}.warranty_details.report_notes`}
                />
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '3%' }}>
                    <FormikCheckbox
                        label='Will Need to Return'
                        name={`${valuePrefix}.warranty_details.is_will_need_to_return`}
                        checked={values.warranty_details.is_will_need_to_return}
                        style={{ marginRight: '10%' }}
                    />
                    <FormikCheckbox
                        name={`${valuePrefix}.is_invoiced`}
                        label='Invoiced'
                        checked={values && values.is_invoiced}
                    />
                </div>
                <FormikDate
                    name={`${valuePrefix}.warranty_details.invoice_date`}
                    label='Invoice Date'
                    groupStyles={halfWidthStyle}
                />
                {values.status?.id === AWAITING_BUILDER_STATUS &&
                    <FormikDate
                        name={`${valuePrefix}.awaiting_builder_date`}
                        label='Awaiting Builder Date'
                        groupStyles={halfWidthStyle}
                    />
                }
            </Col>
        </Row>
    )
}

const MobileReadOnlyScheduleEntry = ({ scheduleEntry }) => (
    <>
        <p>{scheduleEntry.fieldworker ? scheduleEntry.fieldworker.name : '(No Worker)'}</p>
        <p>{scheduleEntry.start ? moment(scheduleEntry.start).format('MM/DD/YYYY h:mm a') : '(No Start)'}</p>
        <p>{scheduleEntry.end ? moment(scheduleEntry.end).format('MM/DD/YYYY h:mm a') : '(No End)'}</p>
        <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{scheduleEntry.completion || '(Incomplete)'}</p>
        <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{scheduleEntry.additional_notes || '(No Notes)'}</p>
    </>
)

const MobileEditScheduleEntry = ({ idx, valuePrefix, employees }) => (
    <Card>
        <FormikSelect
            label='Fieldworker'
            key={`${valuePrefix}.warranty_details.schedule-${idx}-fieldworker`}
            name={`${valuePrefix}.warranty_details.schedule.${idx}.fieldworker`}
            items={employees}
            nullable
        />
        <FormikCustomDateTimePicker
            label='Start'
            step='900'
            placeholder='MM/DD/YYYY --:-- --'
            key={`${valuePrefix}.warranty_details.schedule-${idx}-start`}
            name={`${valuePrefix}.warranty_details.schedule.${idx}.start`}
            dependentName={`${valuePrefix}.warranty_details.schedule.${idx}.end`}
            dependentValueCalculation={parsedValue => parsedValue
                ? moment(parsedValue, 'YYYY-MM-DDTHH:mm:ss').add(1, 'h').format('YYYY-MM-DDTHH:mm:ss')
                : null
            }

        />
        <FormikCustomDateTimePicker
            label='End'
            key={`${valuePrefix}.warranty_details.schedule-${idx}-end`}
            name={`${valuePrefix}.warranty_details.schedule.${idx}.end`}
            step='900'
            placeholder='MM/DD/YYYY --:-- --'
        />
        <FormikTextArea
            label='Completion'
            key={`${valuePrefix}.warranty_details.schedule-${idx}-completion`}
            name={`${valuePrefix}.warranty_details.schedule.${idx}.completion`}
        />
        <FormikTextArea
            label='Additional Notes'
            key={`${valuePrefix}.warranty_details.schedule-${idx}-additional_notes`}
            name={`${valuePrefix}.warranty_details.schedule.${idx}.additional_notes`}
            placeholder="notes..."
        />
    </Card>
)

const MobileReadOnlyPebbleDetailEntry = ({ pebbleDetailEntry }) => (
    <>
        <p>{pebbleDetailEntry?.app_date !== '---' ? moment(moment(pebbleDetailEntry.app_date)).format('MM/DD/YYYY') : '(No App Date)'}</p>
        <p>{pebbleDetailEntry?.detail_date !== '---' ? moment(moment(pebbleDetailEntry.detail_date)).format('MM/DD/YYYY') : '(No Detail Date)'}</p>
        <p>{pebbleDetailEntry.color || '(No Color)'}</p>
        <p>{pebbleDetailEntry.additions || '(No Addition)'}</p>
        <p>{pebbleDetailEntry.section || '(No Section)'}</p>
        <p>{pebbleDetailEntry.crew || '(No Crew)'}</p>
        <p>{pebbleDetailEntry.detail_crew || '(No Detail Crew)'}</p>
    </>
)

const MobileEditPebbleDetailEntry = ({ pebbleDetailEntry, idx, valuePrefix, pebbleColors, pebbleColorAdditives, poolSections, crews }) => (
    <Card>
        <FormikDate
            label='App Date'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-app_date`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.app_date`}
        />
        <FormikDate
            label='Detail Date'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-detail_date`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.detail_date`}
        />
        <FormikSuggestWithCreate
            label='Color'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-color`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.color`}
            value={pebbleDetailEntry.color}
            items={pebbleColors}
        />
        <FormikSuggestWithCreate
            label='Addition'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-additions`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.additions`}
            value={pebbleDetailEntry.additions}
            items={pebbleColorAdditives}
        />
        <FormikSuggestWithCreate
            label='Section'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-section`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.section`}
            value={pebbleDetailEntry.section}
            items={poolSections}
        />
        <FormikSuggestWithCreate
            label='Crew'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-crew`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.crew`}
            value={pebbleDetailEntry.crew}
            items={crews}
        />
        <FormikSuggestWithCreate
            label='Detail Crew'
            key={`${valuePrefix}.warranty_details.pebble_details-${idx}-detail_crew`}
            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.detail_crew`}
            value={pebbleDetailEntry.detail_crew}
            items={crews}
        />
    </Card>
)

const MobileReadOnlyCrewRepairEntry = ({ crewRepairEntry }) => (
    <>
        <p>{crewRepairEntry.date && crewRepairEntry.date !== '---' ? moment(moment(crewRepairEntry.date)).format('MM/DD/YYYY') : '(No Date)'}</p>
        <p>{crewRepairEntry.company_division?.name || '(No Department)'}</p>
        <p>{crewRepairEntry.crew?.name || '(No Crew)'}</p>
        <p>{crewRepairEntry.status?.name || '(No Status)'}</p>
        <p style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{crewRepairEntry.notes || '(No Notes)'}</p>
    </>
)

const MobileEditCrewRepairEntry = ({ crewRepairEntry, idx, valuePrefix, companyDivisions, crews,
    calculateCrewOnCompanyDivisionChange, calculateStatusOnCompanyDivisionChange,
    calculatePhaseTypeOnCompanyDivisionChange, filterCrewsByDepartment,
    calculatePhaseTypeOnCrewChange, calculateStatusOnCrewChange, getStatusOptions }) => (
    <Card>
        <FormikDate
            label='Date'
            key={`${valuePrefix}.warranty_details.crew_repair-${idx}-date`}
            name={`${valuePrefix}.warranty_details.crew_repair-${idx}.date`}
        />
        <FormikSimpleSelect
            key={`company_division-${idx}-${crewRepairEntry.company_division}`}
            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.company_division`}
            items={companyDivisions}
            nullable
            listenerComponents={[
                {
                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.crew`,
                    componentNewValueCalculator: (a, b, c) => calculateCrewOnCompanyDivisionChange(a, b, c),
                    supportingProps: { preChangeEntry: crewRepairEntry }
                },
                {
                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`,
                    componentNewValueCalculator: (a, b, c) => calculateStatusOnCompanyDivisionChange(a, b, c),
                    supportingProps: { preChangeEntry: crewRepairEntry }
                },
                {
                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.pebble_phase_type`,
                    componentNewValueCalculator: (a, b, c) => calculatePhaseTypeOnCompanyDivisionChange(a, b, c),
                    supportingProps: {}
                },
            ]}
        />
        <FormikSelect
            nullable
            key={`crew-${idx}-${crewRepairEntry.crew}`}
            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.crew`}
            items={filterCrewsByDepartment(crewRepairEntry.company_division, crews)}
            listenerComponents={[
                {
                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.pebble_phase_type`,
                    componentNewValueCalculator: (a, b, c) => calculatePhaseTypeOnCrewChange(a, b, c),
                    supportingProps: {}
                },
                {
                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`,
                    componentNewValueCalculator: (a, b, c) => calculateStatusOnCrewChange(a, b, c),
                    supportingProps: { preChangeEntry: crewRepairEntry }
                },
            ]}
        />
        <FormikSimpleSelect
            key={`status-${idx}-${crewRepairEntry.status}`}
            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`}
            items={getStatusOptions(crewRepairEntry.crew, crewRepairEntry.company_division)}
            nullable
        />
        <FormikTextArea
            key={`notes-${idx}-${crewRepairEntry.notes}`}
            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.notes`}
        />
    </Card>
)

export const WarrantyWorkDetailsForm = ({
                                            valuePrefix,
                                            values,
                                            employees,
                                            crews,
                                            poolSections,
                                            pebbleColors,
                                            pebbleSummaryDetails,
                                            pebbleColorAdditives,
                                            jobStatuses,
                                            companyDivisions
                                        }) => {
    const defaultNewScheduleEntry = {
        id: -1,
        job_detail_id: values.id || -1,
    }
    const defaultNewPebbleDetailEntry = {
        id: -1,
        job_detail_id: values.id || -1,
    }

    const defaultNewCrewRepairJobEntry = {
        id: -1,
        job_detail_id: values.id || -1,
        company_division: null
    }

    const isMobile = useMediaQuery({ query: '(max-width: 800px)' })
    const smallScreenNonMobile = useMediaQuery({ query: '(max-width: 870px)' })
    const mediumScreenNonMobile = useMediaQuery({ query: '(max-width: 1500px)' })

    const crewRepairCompanyDivisions = companyDivisions?.filter(c => [2, 3].includes(c.id)) || [] //Gunite & Pebble options only
    const crewRepairJobStatues = jobStatuses.filter(s => (s.show_pebble_prep || s.show_pebble_application || s.show_pebble_detail || s.show_gunite) && (s.id !== AWAITING_BUILDER_STATUS && s.id !== COLOR_OUT_OF_STOCK_STATUS))
    const prepStatuses = crewRepairJobStatues.filter(s => s.show_pebble_prep)
    const applicationStatuses = crewRepairJobStatues.filter(s => s.show_pebble_application)
    const detailStatuses = crewRepairJobStatues.filter(s => s.show_pebble_detail)
    const guniteStatuses = crewRepairJobStatues.filter(s => s.show_gunite && s.id !== AWAITING_BUILDER_STATUS).map(s => ({
        ...s, name: s.name === 'Weeping' ? 'Cave In' : s.name
    }))

    const calculateCrewOnCompanyDivisionChange = (_, newCompanyDivision, { preChangeEntry }) => {
        const isValid = preChangeEntry?.crew?.id &&
            preChangeEntry.crew.lookup_company_division_id === newCompanyDivision?.id

        return isValid
            ? preChangeEntry.crew   //if a blank phase is received or the crew remaines valid for a nonBlank phase, leave it the same
            : null                 //else make it null
    }


    const calculateStatusOnCompanyDivisionChange = (_, newCompanyDivision, { preChangeEntry }) => {
        const selectedSubdivision = preChangeEntry?.crew?.subdivision?.toLowerCase()

        const isValid = selectedSubdivision &&
            (preChangeEntry?.crew?.id &&
                preChangeEntry.crew.lookup_company_division_id === newCompanyDivision?.id
            ) &&
            (
                (selectedSubdivision?.includes('prep') && prepStatuses.findIndex(s => s.id === preChangeEntry.status?.id) !== -1) ||
                (selectedSubdivision?.includes('app') && applicationStatuses.findIndex(s => s.id === preChangeEntry.status?.id) !== -1) ||
                (selectedSubdivision?.includes('detail') && detailStatuses.findIndex(s => s.id === preChangeEntry.status?.id) !== -1) ||
                (selectedSubdivision?.includes('gunite') && guniteStatuses.findIndex(s => s.id === preChangeEntry.status?.id) !== -1)
            )

        return isValid ? preChangeEntry.status : null
    }

    const calculatePhaseTypeOnCrewChange = (_, newCrewEntry, supportingProp) => {
        const selectedSubdivision = newCrewEntry?.subdivision?.toLowerCase()
        return selectedSubdivision?.includes('prep')
            ? { id: 1 }
            : selectedSubdivision?.includes('app')
                ? { id: 2 }
                : selectedSubdivision?.includes('detail')
                    ? { id: 3 }
                    : null

    }

    const calculatePhaseTypeOnCompanyDivisionChange = (_, newCompanyDivisionEntry, supportingProp) => {
        return null
    }

    const calculateStatusOnCrewChange = (_, newCrewEntry, { preChangeEntry }) => {
        const newCrewSubdivision = newCrewEntry?.subdivision?.toLowerCase()
        const selectedSubdivision = preChangeEntry?.crew?.subdivision?.toLowerCase()

        const isValid = selectedSubdivision && newCrewSubdivision
            && selectedSubdivision === newCrewSubdivision

        return isValid ? preChangeEntry.status : null

    }
    const filterCrewsByDepartment = (company_division, crews) => {
        return !company_division || !company_division.id
            ? []
            : crews.filter(c => c?.lookup_company_division_id === company_division.id && c?.is_active)
    }

    const getStatusOptions = (selectedCrew, selectedDepartment) => {
        if (selectedCrew) {
            const selectedSubdivision = selectedCrew?.subdivision?.toLowerCase()

            return selectedSubdivision?.includes('prep')
                ? prepStatuses
                : selectedSubdivision?.includes('app')
                    ? applicationStatuses
                    : selectedSubdivision?.includes('detail')
                        ? detailStatuses
                        : selectedSubdivision?.includes('gunite')
                            ? guniteStatuses
                            : crewRepairJobStatues
        }
        else if (selectedDepartment) {
            return selectedDepartment?.id === 2
                ? guniteStatuses
                : selectedDepartment?.id === 3
                    ? applicationStatuses
                    : []
        }
        else {
            return []
        }
    }

    return (<>
        <H5>Work Details</H5>
        <Row>
            <Col lg={2}>
                <FormikSimpleSelect
                    items={crews}
                    label='Gunite Crew'
                    name={`${valuePrefix}.warranty_details.gunite_crew`}
                    nullable
                    style={{
                        whiteSpace: 'normal',
                        height: 'fit-content',
                        minHeight: 30,
                        padding: '5px 25px 5px 10px'
                    }}
                />
                <FormikDate
                    label='Gunite Application Date'
                    name={`${valuePrefix}.warranty_details.gunite_application_date`}
                />
                <FormikTextArea
                    name={`${valuePrefix}.warranty_details.pool_info`}
                    label='Pool Info'
                />
                <FormikCheckboxArray
                    name={`${valuePrefix}.warranty_details.pool_sections`}
                    value={values.warranty_details.pool_sections}
                    label='Pool Sections'
                    items={poolSections}
                />
            </Col>
            <Col lg={10}>
                <Row>
                    <Col lg={12}>
                        {isMobile && <Divider style={dividerStyle} />}
                        <H5>Schedule</H5>
                        {isMobile && <Divider />}
                        <FieldArray
                            name={`${valuePrefix}.warranty_details.schedule`}
                            render={({ push, remove }) => (!isMobile
                                ? <Table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>
                                                Fieldworker
                                            </th>
                                            {mediumScreenNonMobile
                                                ? <th>
                                                    Start/End
                                                </th>
                                                : <>
                                                    <th>
                                                        Start
                                                    </th>
                                                    <th>
                                                        End
                                                    </th>
                                                </>}
                                            <th>
                                                Completion
                                            </th>
                                            <th>
                                                Additional Notes
                                            </th>
                                            <th style={rightAlignTextStyle}>
                                                <Button icon='plus' intent='primary' text={smallScreenNonMobile ? '' : 'Add'} onClick={() => push(defaultNewScheduleEntry)} />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {values?.warranty_details?.schedule.map((entry, idx) => {
                                        return (
                                            <tr key={`${valuePrefix}.warranty_details.schedule-${idx}`}>
                                                <td
                                                    className='warranty-details-fieldworker'
                                                    style={{
                                                        minWidth: '15ch',
                                                        padding: smallScreenNonMobile ? 4 : 11
                                                    }}
                                                >
                                                    <FormikSelect
                                                            key={`fieldworker-${idx}-${entry.fieldworker}`}
                                                            name={`${valuePrefix}.warranty_details.schedule.${idx}.fieldworker`}
                                                            items={employees}
                                                            disableMaxListSize
                                                            preFilterPredicateKey='is_active'
                                                            nullable
                                                        />
                                                    </td>
                                                    <td
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                        style={{
                                                            minWidth: '18ch',
                                                            padding: smallScreenNonMobile ? 4 : 11
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <FormikCustomDateTimePicker
                                                                step='900'
                                                                placeholder='Start date & time...'
                                                                key={`start-${idx}-${entry.start}`}
                                                                name={`${valuePrefix}.warranty_details.schedule.${idx}.start`}
                                                                dependentName={`${valuePrefix}.warranty_details.schedule.${idx}.end`}
                                                                dependentValueCalculation={parsedValue => parsedValue
                                                                    ? moment(parsedValue, 'YYYY-MM-DDTHH:mm:ss').add(1, 'h').format('YYYY-MM-DDTHH:mm:ss')
                                                                    : null
                                                                }
                                                                groupStyles={{
                                                                    marginRight: mediumScreenNonMobile ? 0 : 10
                                                                }}
                                                            />
                                                            <FormikCustomDateTimePicker
                                                                key={`end-${idx}-${entry.end}`}
                                                                name={`${valuePrefix}.warranty_details.schedule.${idx}.end`}
                                                                step='900'
                                                                placeholder='End date & time...'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td
                                                        style={{
                                                            padding: smallScreenNonMobile ? 4 : 11
                                                        }}
                                                    >
                                                        <FormikTextArea
                                                            key={`completion-${idx}-${entry.completion}`}
                                                            name={`${valuePrefix}.warranty_details.schedule.${idx}.completion`}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{
                                                            padding: smallScreenNonMobile ? 4 : 11
                                                        }}
                                                    >
                                                        <FormikTextArea
                                                            key={`additional_notes-${idx}-${entry.additional_notes}`}
                                                            name={`${valuePrefix}.warranty_details.schedule.${idx}.additional_notes`}
                                                            placeholder="notes..."
                                                        />
                                                    </td>
                                                    <td style={rightAlignTextStyle}>
                                                        <Icon icon='delete' iconSize='25' intent='danger' onClick={() => remove(idx)} />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                                : <Row>
                                        {values?.warranty_details?.schedule.map((scheduleEntry, idx, ar) => {
                                            return (
                                                <Col xs={6}>
                                                    <MobileListCard
                                                        idx={idx}
                                                        onRemove={remove.bind(null, idx)}
                                                        dialogTitle='Schedule Entry'
                                                        autoOpen={(scheduleEntry.createdOnMobile && ((ar.length - 1) === idx) && (scheduleEntry.id === -1))}
                                                        readOnlyContent={<MobileReadOnlyScheduleEntry
                                                            scheduleEntry={scheduleEntry}/>}
                                                        editViewContent={<MobileEditScheduleEntry idx={idx}
                                                                                                  valuePrefix={valuePrefix}
                                                                                                  employees={employees}/>}
                                                    />
                                            </Col>
                                        )
                                    })}
                                    <Col xs={6}>
                                        <AddCard onClick={() => push({ ...defaultNewScheduleEntry, createdOnMobile: true })} />
                                    </Col>
                                </Row>
                            )}
                        />
                    </Col>
                </Row>
                <Divider style={dividerStyle} />
                <Row>
                    <Col lg={12}>
                        <H5>Pebble Details</H5>
                        {isMobile && <Divider />}
                        <FieldArray
                            name={`${valuePrefix}.warranty_details.pebble_details`}
                            render={({ push, remove }) => (!isMobile
                                ? <Table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            {mediumScreenNonMobile
                                                ? <th>
                                                    App & Detail Date
                                                </th>
                                                : <>
                                                    <th>
                                                        App Date
                                                    </th>
                                                    <th>
                                                        Detail Date
                                                    </th>
                                                </>}
                                            {mediumScreenNonMobile
                                                ? <th>
                                                    Color/Additions
                                                </th>
                                                : <>
                                                    <th>
                                                        Color
                                                    </th>
                                                    <th>
                                                        Additions
                                                    </th>
                                                </>}
                                            <th>
                                                Section
                                            </th>
                                            {mediumScreenNonMobile
                                                ? <th>
                                                    App Crew & Detail Crew
                                                </th>
                                                : <>
                                                    <th>
                                                        Crew
                                                    </th>
                                                    <th>
                                                        Detail Crew
                                                    </th>
                                                </>}
                                            <th style={rightAlignTextStyle}>
                                                <Button icon='plus' intent='primary' text={smallScreenNonMobile ? '' : 'Add'} onClick={() => push(defaultNewPebbleDetailEntry)} />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pebbleSummaryDetails?.map((entry, idx) => {
                                            return (
                                                <tr key={`pebbleSummaryDetails-${idx}`}>
                                                    <td
                                                        style={{padding: smallScreenNonMobile ? 4 : 11}}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-around'
                                                            }}
                                                        >
                                                            <span key={`pebbleSummaryDetails-${idx}-app_date`}>{entry.app_date}</span>
                                                            <span key={`pebbleSummaryDetails-${idx}-detail_date`}>{entry.detail_date}</span>
                                                        </div>
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between'
                                                            }}
                                                        >
                                                            <div
                                                                style={{width: mediumScreenNonMobile ? '100%' : '50%'}}>
                                                                <span
                                                                    key={`pebbleSummaryDetails-${idx}-color`}>{entry.color}</span>
                                                            </div>
                                                            {mediumScreenNonMobile && entry.color && entry.additions &&
                                                                <hr style={{width: '100%', color: '#2222'}}/>}
                                                            <div
                                                                style={{width: mediumScreenNonMobile ? '100%' : '50%'}}>
                                                                <span
                                                                    key={`pebbleSummaryDetails-${idx}-additions`}>{entry.additions}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: smallScreenNonMobile ? 4 : 11 }}>
                                                        <span key={`pebbleSummaryDetails-${idx}-section`}>{entry.section}</span>
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-around'
                                                            }}
                                                        >
                                                            <span
                                                                key={`pebbleSummaryDetails-${idx}-crew`}>{entry.crew}</span>
                                                            <span
                                                                key={`pebbleSummaryDetails-${idx}-detail_crew`}>{entry.detail_crew}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        }
                                        {values?.warranty_details?.pebble_details.map((entry, idx) => {
                                            return (
                                                <tr key={`${valuePrefix}.warranty_details.pebble_details-${idx}`}>
                                                    <td
                                                        style={{padding: smallScreenNonMobile ? 4 : 11}}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <FormikDate
                                                                key={`app_date-${idx}-${entry.app_date}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.app_date`}
                                                                groupStyles={{
                                                                    marginRight: mediumScreenNonMobile ? 0 : 10
                                                                }}
                                                                placeholder='App Date...'
                                                            />
                                                            <FormikDate
                                                                key={`detail_date-${idx}-${entry.detail_date}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.detail_date`}
                                                                placeholder='Detail Date...'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'left'
                                                            }}
                                                        >
                                                            <FormikSuggestWithCreate
                                                                key={`color-${idx}-${entry.color}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.color`}
                                                                value={entry.color}
                                                                items={pebbleColors}
                                                                style={{ marginRight: mediumScreenNonMobile ? 0 : 10 }}
                                                                placeholder='Color...'
                                                            />
                                                            <FormikSuggestWithCreate
                                                                key={`additions-${idx}-${entry.additions}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.additions`}
                                                                value={entry.additions}
                                                                items={pebbleColorAdditives}
                                                                style={{ width: smallScreenNonMobile ? '185%' : mediumScreenNonMobile ? '200%' : 'auto' }}
                                                                placeholder='Additions...'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: smallScreenNonMobile ? 4 : 11 }} >
                                                        <FormikSuggestWithCreate
                                                            key={`section-${idx}-${entry.section}`}
                                                            name={`${valuePrefix}.warranty_details.pebble_details.${idx}.section`}
                                                            value={entry.section}
                                                            items={poolSections}
                                                            placeholder='Section...'
                                                        />
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                        colSpan={mediumScreenNonMobile ? 1 : 2}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: mediumScreenNonMobile ? 'column' : 'row',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <FormikSuggestWithCreate
                                                                key={`crew-${idx}-${entry.crew}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.crew`}
                                                                value={entry.crew}
                                                                items={crews}
                                                                style={{
                                                                    marginRight: mediumScreenNonMobile ? 0 : 10
                                                                }}
                                                                placeholder='App Crew...'
                                                            />
                                                            <FormikSuggestWithCreate
                                                                key={`detail_crew-${idx}-${entry.detail_crew}`}
                                                                name={`${valuePrefix}.warranty_details.pebble_details.${idx}.detail_crew`}
                                                                value={entry.detail_crew}
                                                                items={crews}
                                                                placeholder='Detail Crew...'
                                                            />
                                                        </div>
                                                    </td>
                                                    <td style={rightAlignTextStyle}>
                                                        <Icon icon='delete' iconSize='25' intent='danger' onClick={() => remove(idx)} />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                                : <Row>
                                        {pebbleSummaryDetails?.map((pebbleDetailEntry, idx) => {
                                            return (
                                                <Col xs={6}>
                                                    <MobileListCard
                                                        idx={idx}
                                                        uneditable
                                                        unremovable
                                                        readOnlyContent={<MobileReadOnlyPebbleDetailEntry
                                                            pebbleDetailEntry={pebbleDetailEntry}/>}
                                                    />
                                                </Col>
                                            )
                                        })}
                                        {values?.warranty_details?.pebble_details.map((pebbleDetailEntry, idx, ar) => {
                                            return (
                                                <Col xs={6}>
                                                    <MobileListCard
                                                        idx={idx}
                                                        onRemove={remove.bind(null, idx)}
                                                        dialogTitle='Pebble Detail Entry'
                                                        autoOpen={(pebbleDetailEntry.createdOnMobile && ((ar.length - 1) === idx) && (pebbleDetailEntry.id === -1))}
                                                        readOnlyContent={<MobileReadOnlyPebbleDetailEntry
                                                            pebbleDetailEntry={pebbleDetailEntry}/>}
                                                        editViewContent={<MobileEditPebbleDetailEntry
                                                            pebbleDetailEntry={pebbleDetailEntry} idx={idx}
                                                            valuePrefix={valuePrefix} pebbleColors={pebbleColors}
                                                        pebbleColorAdditives={pebbleColorAdditives} poolSections={poolSections} crews={crews}
                                                    />}
                                                />
                                            </Col>
                                        )
                                    })}
                                    <Col xs={6}>
                                        <AddCard onClick={() => push({ ...defaultNewPebbleDetailEntry, createdOnMobile: true })} />
                                    </Col>
                                </Row>
                            )}
                        />
                    </Col>
                </Row>
                <Divider style={dividerStyle} />
                <Row>
                    <Col lg={12}>
                        <H5>Crew Repair Jobs</H5>
                        {isMobile && <Divider />}
                        <FieldArray
                            name={`${valuePrefix}.warranty_details.crew_repair_jobs`}
                            render={({ push, remove }) => (!isMobile
                                ? <Table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Department</th>
                                            <th>Crew</th>
                                            <th>Status</th>
                                            <th>Notes</th>
                                            <th style={rightAlignTextStyle}>
                                                <Button icon='plus' intent='primary' text={smallScreenNonMobile ? '' : 'Add'} onClick={() => push(defaultNewCrewRepairJobEntry)} />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {values?.warranty_details?.crew_repair_jobs.map((entry, idx) => {
                                        return (
                                            <tr key={`${valuePrefix}.warranty_details.crew_repair_jobs-${idx}`}>
                                                <td
                                                    style={{
                                                        padding: smallScreenNonMobile ? 4 : 11,
                                                        minWidth: '12ch',
                                                        maxWidth: '12ch'
                                                    }}
                                                >
                                                    <FormikDate
                                                            key={`date-${idx}-${entry.date}`}
                                                            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.date`}
                                                            placeholder='Date'
                                                            style={{
                                                                padding: '5px 25px 5px 10px'
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                    >
                                                        <FormikSimpleSelect
                                                            key={`company_division-${idx}-${entry.company_division}`}
                                                            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.company_division`}
                                                            items={crewRepairCompanyDivisions}
                                                            nullable
                                                            listenerComponents={[
                                                                {
                                                                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.crew`,
                                                                    componentNewValueCalculator: (a, b, c) => calculateCrewOnCompanyDivisionChange(a, b, c),
                                                                    supportingProps: { preChangeEntry: entry }
                                                                },
                                                                {
                                                                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`,
                                                                    componentNewValueCalculator: (a, b, c) => calculateStatusOnCompanyDivisionChange(a, b, c),
                                                                    supportingProps: { preChangeEntry: entry }
                                                                },
                                                                {
                                                                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.pebble_phase_type`,
                                                                    componentNewValueCalculator: (a, b, c) => calculatePhaseTypeOnCompanyDivisionChange(a, b, c),
                                                                    supportingProps: {}
                                                                },
                                                            ]}
                                                            style={{
                                                                whiteSpace: 'normal',
                                                                height: 'fit-content',
                                                                minHeight: 30
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{
                                                            padding: smallScreenNonMobile ? 4 : 11,
                                                            minWidth: '12ch'
                                                        }}
                                                    >
                                                        <FormikSelect
                                                            nullable
                                                            disableMaxListSize
                                                            key={`crew-${idx}-${entry.crew}`}
                                                            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.crew`}
                                                            items={filterCrewsByDepartment(values.warranty_details.crew_repair_jobs[idx].company_division, crews)}
                                                            listenerComponents={[
                                                                {
                                                                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.pebble_phase_type`,
                                                                    componentNewValueCalculator: (a, b, c) => calculatePhaseTypeOnCrewChange(a, b, c),
                                                                    supportingProps: {}
                                                                },
                                                                {
                                                                    componentName: `${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`,
                                                                    componentNewValueCalculator: (a, b, c) => calculateStatusOnCrewChange(a, b, c),
                                                                    supportingProps: { preChangeEntry: entry }
                                                                },
                                                            ]}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{
                                                            padding: smallScreenNonMobile ? 4 : 11,
                                                            minWidth: '12ch'
                                                        }}
                                                    >
                                                        <FormikSimpleSelect
                                                            key={`status-${idx}-${entry.status}`}
                                                            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.status`}
                                                            items={getStatusOptions(values.warranty_details.crew_repair_jobs[idx].crew, values.warranty_details.crew_repair_jobs[idx].company_division)}
                                                            nullable
                                                            style={{
                                                                whiteSpace: 'normal',
                                                                height: 'fit-content',
                                                                minHeight: 30,
                                                                padding: '5px 25px 5px 10px'
                                                            }}
                                                        />
                                                    </td>
                                                    <td
                                                        style={{ padding: smallScreenNonMobile ? 4 : 11 }}
                                                    >
                                                        <FormikTextArea
                                                            key={`notes-${idx}-${entry.notes}`}
                                                            name={`${valuePrefix}.warranty_details.crew_repair_jobs.${idx}.notes`}
                                                            style={{
                                                                minWidth: '15ch'
                                                            }}
                                                        />
                                                    </td>
                                                    <td style={rightAlignTextStyle}>
                                                        <Icon icon='delete' iconSize='25' intent='danger' onClick={() => remove(idx)} />
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                                : <Row>
                                        {values?.warranty_details?.crew_repair_jobs.map((warrantyCrewRepairEntry, idx, ar) => {
                                            return (
                                                <Col xs={6}>
                                                    <MobileListCard
                                                        idx={idx}
                                                        onRemove={remove.bind(null, idx)}
                                                        dialogTitle='Crew Repair Entry'
                                                        autoOpen={(warrantyCrewRepairEntry.createdOnMobile && ((ar.length - 1) === idx) && (warrantyCrewRepairEntry.id === -1))}
                                                        readOnlyContent={<MobileReadOnlyCrewRepairEntry
                                                            crewRepairEntry={warrantyCrewRepairEntry}/>}
                                                        editViewContent={<MobileEditCrewRepairEntry
                                                            crewRepairEntry={warrantyCrewRepairEntry} idx={idx}
                                                            valuePrefix={valuePrefix}
                                                            companyDivisions={crewRepairCompanyDivisions}
                                                        crews={crews}
                                                        calculateStatusOnCompanyDivisionChange={calculateStatusOnCompanyDivisionChange}
                                                        calculateCrewOnCompanyDivisionChange={calculateCrewOnCompanyDivisionChange}
                                                        calculatePhaseTypeOnCompanyDivisionChange={calculatePhaseTypeOnCompanyDivisionChange}
                                                        filterCrewsByDepartment={filterCrewsByDepartment}
                                                        calculatePhaseTypeOnCrewChange={calculatePhaseTypeOnCrewChange}
                                                        calculateStatusOnCrewChange={calculateStatusOnCrewChange}
                                                        getStatusOptions={getStatusOptions}
                                                    />}
                                                />
                                            </Col>
                                        )
                                    })}
                                </Row>
                            )}
                        />
                    </Col>
                </Row>
                <Divider style={dividerStyle} />
                <Row>
                    <Col lg={12}>
                        <GeneralComments
                            name={`${valuePrefix}.general_comments`}
                            generalComments={values?.general_comments}
                            jobDetailId={values.id}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    </>
    )
}
